export default __webpack_public_path__ + "static/media/exercise.6b4dc74b.gif";